/**
 * The e-signature "words on the document" test, ported from
 * KeywordPlacement::runMatchesKeyword() (api/app/Services/Esign/KeywordPlacement.php),
 * which is itself a port of the legacy stamper's rule:
 *
 *   stripos(trim($runText), $keyword) !== false
 *
 * - The run is trimmed with PHP's default character list; the keyword is NOT.
 * - PHP 8 stripos folds ASCII letters only ("É" and "é" stay different).
 * - A keyword that trims to nothing matches nothing.
 *
 * The editor uses this to highlight matches the moment words are typed; the
 * server's answer replaces it once it arrives for the same words.
 *
 * Copied from corp-dashboard/lib/esign/match.ts.
 */

/** PHP trim()'s default character list: " \t\n\r\0\x0B". */
const PHP_TRIM_CHARS = ' \t\n\r\0\x0B';

export function phpTrim(value: string): string {
  let start = 0;
  let end = value.length;
  while (start < end && PHP_TRIM_CHARS.includes(value[start])) start++;
  while (end > start && PHP_TRIM_CHARS.includes(value[end - 1])) end--;
  return value.slice(start, end);
}

/** Lower-case A-Z only, like PHP 8's locale-independent stripos. */
export function foldAscii(value: string): string {
  return value.replace(/[A-Z]/g, (c) => c.toLowerCase());
}

export function runMatchesKeyword(runText: string, keyword: string): boolean {
  if (phpTrim(keyword) === '') return false;
  return foldAscii(phpTrim(runText)).indexOf(foldAscii(keyword)) !== -1;
}
